module.exports = __webpack_public_path__ + "static/media/openstudy_02.30223b15.jpg";